<template>
  <!-- -->
  <div class="defaultViewStyle">
    <list-page>
      <page-header>
        <template #default>
          <page-button el-type="primary" @click="resetSearch">查询</page-button>
        </template>
      </page-header>
      <search-condition @search="resetSearch">
        <el-input v-model="searchInfo.searchKey" placeholder="请填写任务描述" @keydown.enter="resetSearch"/>
        <el-select v-model="searchInfo.jobGroup" placeholder="请选择执行器" clearable @change="resetSearch">
          <el-option v-for="(it,idx) in executorList" :key="idx" :label="it.groupName" :value="it.jobGroup"/>
        </el-select>
      </search-condition>
      <table-list>
        <el-table stripe :data="dataList" height="100%">
<!--          <el-table-column align="center" label="任务编号" min-width="60px" prop="id"/>-->
          <el-table-column align="center" label="序号" width="60px" type="index"/>
          <el-table-column align="center" label="任务描述" min-width="140px" prop="jobDesc" show-overflow-tooltip/>
          <el-table-column align="center" label="作者" min-width="120px" prop="author"/>
          <el-table-column align="center" label="执行频率" min-width="130px" prop="scheduleConf"/>
          <el-table-column align="center" label="下次执行" min-width="150px">
            <template v-slot="{row}">
              {{ row.triggerNextTime ? Util.formatTimestamp(row.triggerNextTime) : '未启用' }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" min-width="150px" prop="triggerStatus">
            <template v-slot="{row}">
              <el-tag :type="row.triggerStatus === 1 ? 'success' : 'danger'">
                {{ row.triggerStatus === 1 ? '启用' : '停用' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" :align="'center'" width="150px">
            <template v-slot="{row}">
              <list-button>
                <page-button el-type="success" @click="runJob(row)">执行一次</page-button>
                <page-button el-type="danger" :disabled="row.triggerStatus === 0" @click="stopJob(row)">停用
                </page-button>
                <page-button el-type="primary" :disabled="row.triggerStatus === 1" @click="startJob(row)">启用
                </page-button>
<!--                <page-button el-type="warning" @click="updateCron(row)">修改频率</page-button>-->
                <page-button el-type="warning" @click="toEdit(row)">编辑</page-button>
              </list-button>
            </template>
          </el-table-column>
        </el-table>
      </table-list>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>

    <!-- 添加编辑弹窗 -->
    <el-dialog
        v-model="editVisible"
        title="编辑任务"
        width="900px"
        :close-on-click-modal="false"
        class="job-edit-dialog"
        @close="closeEdit"
    >
      <div style="overflow: auto;height: 495px;">


        <el-form ref="editForm" :model="editData" label-width="120px" :rules="rules">
          <!-- 基础信息卡片 -->
          <div class="form-card">
            <div class="card-header">基础信息</div>
            <div class="card-content">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="执行器" prop="jobGroup" required>
                    <el-select v-model="editData.jobGroup" placeholder="请选择执行器">
                      <el-option
                          v-for="item in executorList"
                          :key="item.jobGroup"
                          :label="item.groupName"
                          :value="item.jobGroup"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="任务描述" prop="jobDesc" required>
                    <el-input v-model="editData.jobDesc" placeholder="请输入任务描述"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="作者" prop="author">
                    <el-input v-model="editData.author" placeholder="请输入作者名称"/>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="报警邮件" prop="alarmEmail">
                    <el-input v-model="editData.alarmEmail" placeholder="多个邮件地址用逗号分隔"/>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 调度配置卡片 -->
          <div class="form-card">
            <div class="card-header">调度配置</div>
            <div class="card-content">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Cron表达式" prop="scheduleConf" required>
                    <el-input v-model="editData.scheduleConf" placeholder="请输入Cron表达式">
                      <template #append>
                        <page-button el-type="primary" @click="showCronDialog">生成</page-button>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="路由策略" prop="executorRouteStrategy" required>
                    <el-select v-model="editData.executorRouteStrategy" placeholder="请选择路由策略">
                      <el-option label="第一个" value="FIRST"/>
                      <el-option label="最后一个" value="LAST"/>
                      <el-option label="轮询" value="ROUND"/>
                      <el-option label="随机" value="RANDOM"/>
                      <el-option label="一致性HASH" value="CONSISTENT_HASH"/>
                      <el-option label="最不经常使用" value="LEAST_FREQUENTLY_USED"/>
                      <el-option label="最近最久未使用" value="LEAST_RECENTLY_USED"/>
                      <el-option label="故障转移" value="FAILOVER"/>
                      <el-option label="忙碌转移" value="BUSYOVER"/>
                      <el-option label="分片广播" value="SHARDING_BROADCAST"/>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 任务配置卡片 -->
          <div class="form-card">
            <div class="card-header">任务配置</div>
            <div class="card-content">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="运行模式" prop="glueType">
                    <el-select v-model="editData.glueType" disabled>
                      <el-option label="BEAN" value="BEAN"/>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="JobHandler" prop="executorHandler" required>
                    <el-input v-model="editData.executorHandler" placeholder="请输入JobHandler"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="任务参数" prop="executorParam">
                <div class="param-container">
                  <el-select v-model="selectedTemplate" placeholder="选择参数模板" @change="applyTemplate" style="margin-bottom: 10px; width: 100%;">
                    <el-option
                      v-for="(template, index) in paramTemplates"
                      :key="index"
                      :label="template.name"
                      :value="index"
                    />
                  </el-select>
                  <el-input
                    v-model="editData.executorParam"
                    type="textarea"
                    :rows="12"
                    placeholder="请输入任务参数(只支持JSON格式参数)"
                  />
                </div>
              </el-form-item>
            </div>
          </div>

          <!-- 高级配置卡片 -->
          <div class="form-card">
            <div class="card-header">高级配置</div>
            <div class="card-content">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="阻塞策略" prop="executorBlockStrategy" required>
                    <el-select v-model="editData.executorBlockStrategy" placeholder="请选择阻塞处理策略">
                      <el-option label="单机串行" value="SERIAL_EXECUTION"/>
                      <el-option label="丢弃后续调度" value="DISCARD_LATER"/>
                      <el-option label="覆盖之前调度" value="COVER_EARLY"/>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="超时时间" prop="executorTimeout">
                    <el-input-number v-model="editData.executorTimeout" :min="0" placeholder="0为不限制"/>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="失败重试" prop="executorFailRetryCount">
                    <el-input-number v-model="editData.executorFailRetryCount" :min="0" placeholder="0为不重试"/>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div style="display: flex; justify-content: flex-end;padding-top: 10px;">
        <page-button el-type="info" @click="closeEdit">取 消</page-button>
        <page-button el-type="primary" @click="submitEdit">确 定</page-button>
      </div>
    </el-dialog>

    <el-dialog :append-to-body="true" v-model="showCron" title="Cron表达式生成器">
      <vue3-cron-plus-picker @hide="showCron=false" @fill="cronFill" :expression="expression"/>
    </el-dialog>

    <!-- 对象参数输入弹窗 -->
    <el-dialog
      v-model="showObjectParamDialog"
      title="对象参数配置"
      width="600px"
      :close-on-click-modal="false"
      class="param-config-container"
    >
      <el-form :model="objectParamForm" label-width="100px" class="param-form">
        <el-form-item
          v-for="(item, index) in objectParamForm.items"
          :key="index"
          :label="'参数' + (index + 1)"
          class="param-form-item"
        >
          <div class="param-item">
            <div class="param-inputs">
              <el-input v-model="item.key" placeholder="key"/>
              <el-input v-model="item.value" placeholder="value"/>
            </div>
            <el-button type="danger" circle class="delete-btn" @click="removeObjectParam(index)">
              <el-icon><Delete /></el-icon>
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      <div class="add-param-btn">
        <el-button type="primary" @click="addObjectParam()">添加参数</el-button>
      </div>
      <div class="dialog-footer">
        <el-button @click="showObjectParamDialog = false">取消</el-button>
        <el-button type="primary" @click="generateObjectParam">确定</el-button>
      </div>
    </el-dialog>

    <!-- 集合参数输入弹窗 -->
    <el-dialog
      v-model="showCollectionParamDialog"
      :title="collectionType === 'OBJECT' ? '对象集合参数配置' : '普通集合参数配置'"
      width="800px"
      :close-on-click-modal="false"
      :class="collectionType === 'OBJECT' ? 'object-collection' : 'simple-collection'"
    >
      <template v-if="collectionType === 'OBJECT'">
        <div v-for="(object, objectIndex) in objectCollectionForm.items" :key="objectIndex" class="object-container">
          <div class="object-header">
            <div class="object-title">object {{ objectIndex + 1 }}</div>
            <el-button type="danger" circle class="delete-btn" @click="removeObjectCollectionItem(objectIndex)">
              <el-icon><Delete /></el-icon>
            </el-button>
          </div>
          <el-form :model="object" label-width="100px" class="object-form">
            <el-form-item
              v-for="(item, index) in object.params"
              :key="index"
              :label="'参数' + (index + 1)"
              class="param-form-item"
            >
              <div class="param-item">
                <div class="param-inputs">
                  <el-input v-model="item.key" placeholder="key"/>
                  <el-input v-model="item.value" placeholder="value"/>
                </div>
                <el-button type="danger" circle class="delete-btn" @click="removeObjectParam(objectIndex, index)">
                  <el-icon><Delete /></el-icon>
                </el-button>
              </div>
            </el-form-item>
            <div class="add-param-btn">
              <el-button type="primary" @click="addObjectParam(objectIndex)">添加参数</el-button>
            </div>
          </el-form>
        </div>
        <div class="add-object-btn">
          <el-button type="primary" @click="addObjectCollectionItem">添加对象</el-button>
        </div>
      </template>
      <template v-else>
        <el-form :model="simpleCollectionForm" label-width="100px" class="param-form">
          <el-form-item
            v-for="(item, index) in simpleCollectionForm.items"
            :key="index"
            :label="'值' + (index + 1)"
            class="param-form-item"
          >
            <div class="param-item">
              <el-input v-model="item.value" placeholder="参数值" style="width: 550px;" class="full-width-input"/>
              <el-button type="danger" circle class="delete-btn" @click="removeSimpleCollectionItem(index)">
                <el-icon><Delete /></el-icon>
              </el-button>
            </div>
          </el-form-item>
        </el-form>
        <div class="add-value-btn">
          <el-button type="primary" @click="addSimpleCollectionItem">添加值</el-button>
        </div>
      </template>
      <div class="dialog-footer">
        <el-button @click="showCollectionParamDialog = false">取消</el-button>
        <el-button type="primary" @click="generateCollectionParam">确定</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>
import ProductStockComponent from "@/views/main/stock/stockManage/ProductStockComponent.vue";
import ListPage from "@/components/h5/layout/ListPage";
import TableList from "@/components/h5/layout/TableList";
import FormPage from "@/components/h5/layout/FormPage";
import SearchCondition from "@/components/h5/layout/SearchCondition";
import PageButton from "@/components/h5/button/PageButton";
import TableButton from "@/components/h5/button/TableButton";
import Dictionary from "@/components/h5/Dictionary";
import PageHeader from "@/components/h5/layout/PageHeader";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import dataSyncApi from "@/api/main/sync/dataSyncApi";
import ListButton from "@/components/h5/button/ListButton.vue";
import { Delete } from '@element-plus/icons-vue'

import 'vue3-cron-plus-picker/style.css'
import { Vue3CronPlusPicker } from 'vue3-cron-plus-picker'
import Util from "../../../../../util/util";
import {ElMessageBox} from "element-plus";
// 在相关页面文件里局部引入

export default {
  name: "StockList",
  components: {
    ListButton,
    TableButton,
    PageButton,
    SearchCondition, DialogTable,
    ListPage, TableList, FormPage, Dictionary, PageHeader, ProductStockComponent, Vue3CronPlusPicker, Delete
  },
  computed: {
    Util() {
      return Util
    }

  },
  data() {
    return {
      showCron: false,
      searchInfo: {},
      dataList: [],
      cron: "",
      executorList: [],
      editData: {},
      editVisible: false,
      selectedTemplate: null,
      showObjectParamDialog: false,
      showCollectionParamDialog: false,
      collectionType: 'OBJECT', // 'OBJECT' or 'SIMPLE'
      objectParamForm: {
        items: [{ key: '', value: '' }]
      },
      objectCollectionForm: {
        items: [{
          name: '',
          params: [{ key: '', value: '' }]
        }]
      },
      simpleCollectionForm: {
        items: [{ value: '' }]
      },
      paramTemplates: [
        {
          name: "默认参数模板",
          value: {
            "key": "value",
          }
        },
        {
          name: "对象参数模板",
          type: "OBJECT"
        },
        {
          name: "对象集合参数模板",
          type: "COLLECTION",
          subType: "OBJECT"
        },
        {
          name: "普通集合参数模板",
          type: "COLLECTION",
          subType: "SIMPLE"
        }
      ],
      rules: {
        jobGroup: [{required: true, message: '请选择执行器', trigger: 'change'}],
        jobDesc: [{required: true, message: '请输入任务描述', trigger: 'blur'}],
        author: [{required: true, message: '请输入作者', trigger: 'blur'}],
        executorRouteStrategy: [{required: true, message: '请选择路由策略', trigger: 'change'}],
        scheduleConf: [{required: true, message: '请输入Cron表达式', trigger: 'blur'}],
        executorHandler: [{required: true, message: '请输入JobHandler', trigger: 'blur'}],
        executorBlockStrategy: [{required: true, message: '请选择阻塞处理策略', trigger: 'change'}]
      }
    };
  },
  created() {
    // 所有执行器
    dataSyncApi.queryAllExecutor().then(list => {
      this.executorList = list;
      let selectList = list.filter(item => item.defaultFlag === 1);
      const data = selectList[Math.floor(Math.random() * (selectList.length - 1))];
      if(data && data.jobGroup){
        this.searchInfo.jobGroup = data.jobGroup;
      }
      this.resetSearch();
    });
  },
  methods: {
    expression(val){
      // console.log("aaaaaa" + val);
    },
    cronFill(val){
      this.editData.scheduleConf = val;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    queryList() {
      dataSyncApi.queryList(this.searchInfo).then(res => {
        this.dataList = res.records;
        this.searchInfo.totalCount = res.totalCount;
      });
    },
    runJob(row) {
      dataSyncApi.runJob(row.id, row.executorParam).then(() => {
        this.$message.success("执行成功");
      });
    },
    stopJob(row) {
      dataSyncApi.stopJob(row.id).then(() => {
        this.$message.success("停用成功");
        this.queryList();
      })
    },
    startJob(row) {
      dataSyncApi.startJob(row.id).then(() => {
        this.$message.success("启用成功");
        this.queryList();
      })
    },
    updateCron(row) {
      // dataSyncApi.updateJob({jobId: row.id, jobCron: this.cron});
    },
    toEdit(row) {
      this.editData = JSON.parse(JSON.stringify(row)); // 深拷贝，避免直接修改表格数据
      this.editVisible = true;
    },
    closeEdit() {
      this.editVisible = false;
      this.editData = {};
      this.$refs.editForm?.resetFields();
    },
    submitEdit() {
      ElMessageBox.confirm('修改后可能导致该任务不可用,确认修改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error',
      }).then(() => {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            const params = {
              id: this.editData.id,
              jobGroup: this.editData.jobGroup,
              jobDesc: this.editData.jobDesc,
              executorRouteStrategy: this.editData.executorRouteStrategy,
              scheduleType: 'CRON',
              scheduleConf: this.editData.scheduleConf,
              glueType: 'BEAN',
              executorHandler: this.editData.executorHandler,
              executorParam: this.editData.executorParam,
              executorBlockStrategy: this.editData.executorBlockStrategy,
              executorTimeout: this.editData.executorTimeout || 0,
              executorFailRetryCount: this.editData.executorFailRetryCount || 0,
              alarmEmail: this.editData.alarmEmail || '',
              childJobId: this.editData.childJobId || '',
              author: this.editData.author || '未填写'
            };

            dataSyncApi.updateJob(params).then(() => {
              this.$message.success('修改成功');
              this.closeEdit();
              this.queryList();
            }).catch(() => {
              this.$message.error('修改失败');
            });
          }
        });
      })
    },
    showCronDialog() {
      // 这里可以集成Cron表达式生成器组件
      // 可以使用开源组件如 vue-cron 或自定义实现
      this.showCron = true;
    },
    applyTemplate(index) {
      if (index !== null && this.paramTemplates[index]) {
        const template = this.paramTemplates[index];
        if (template.type === 'OBJECT') {
          this.showObjectParamDialog = true;
          this.objectParamForm.items = [{ key: '', value: '' }];
        } else if (template.type === 'COLLECTION') {
          this.showCollectionParamDialog = true;
          this.collectionType = template.subType;
          if (template.subType === 'OBJECT') {
            this.objectCollectionForm.items = [{
              name: '',
              params: [{ key: '', value: '' }]
            }];
          } else {
            this.simpleCollectionForm.items = [{ value: '' }];
          }
        } else {
          this.editData.executorParam = JSON.stringify(template.value, null, 2);
        }
      }
    },
    addObjectParam(objectIndex) {
      if (objectIndex !== undefined) {
        // 处理对象集合中的参数添加
        this.objectCollectionForm.items[objectIndex].params.push({ key: '', value: '' });
      } else {
        // 处理对象参数对话框中的参数添加
        this.objectParamForm.items.push({ key: '', value: '' });
      }
    },
    removeObjectParam(objectIndex, paramIndex) {
      this.objectCollectionForm.items[objectIndex].params.splice(paramIndex, 1);
    },
    generateObjectParam() {
      const result = {};
      this.objectParamForm.items.forEach(item => {
        if (item.key && item.value) {
          result[item.key] = item.value;
        }
      });
      this.editData.executorParam = JSON.stringify(result, null, 2);
      this.showObjectParamDialog = false;
    },
    addObjectCollectionItem() {
      this.objectCollectionForm.items.push({
        name: '',
        params: [{ key: '', value: '' }]
      });
    },
    removeObjectCollectionItem(index) {
      this.objectCollectionForm.items.splice(index, 1);
    },
    addSimpleCollectionItem() {
      this.simpleCollectionForm.items.push({ value: '' });
    },
    removeSimpleCollectionItem(index) {
      this.simpleCollectionForm.items.splice(index, 1);
    },
    generateCollectionParam() {
      let result;
      if (this.collectionType === 'OBJECT') {
        result = this.objectCollectionForm.items.map(object => {
          const obj = {};
          object.params.forEach(param => {
            if (param.key && param.value) {
              obj[param.key] = param.value;
            }
          });
          return {
            ...obj
          };
        });
      } else {
        result = this.simpleCollectionForm.items
          .filter(item => item.value)
          .map(item => item.value);
      }
      this.editData.executorParam = JSON.stringify(result, null, 2);
      this.showCollectionParamDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tables";

.job-edit-dialog {
  :deep(.el-dialog__body) {
    padding: 20px 20px 0;
  }

  .form-card {
    background: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .card-header {
      padding: 12px 20px;
      font-size: 15px;
      font-weight: 600;
      color: #1f2f3d;
      border-bottom: 1px solid #ebeef5;
      background: #fff;
      border-radius: 8px 8px 0 0;
    }

    .card-content {
      padding: 20px;
      background: #fff;
      border-radius: 0 0 8px 8px;
    }


    .param-container{
      width: 100%;
    }
  }

  :deep(.el-form-item) {
    margin-bottom: 18px;

    &:last-child {
      margin-bottom: 0;
    }

    .el-form-item__label {
      font-weight: 500;
      line-height: 54px !important;
      color: #606266;
    }
  }

  :deep(.el-select),
  :deep(.el-input-number) {
    width: 100%;
  }

  :deep(.el-input-number .el-input__wrapper) {
    padding-left: 11px;
    padding-right: 11px;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    padding: 20px 0;

    .el-button + .el-button {
      margin-left: 12px;
    }
  }
}

// 必填项标记样式优化
:deep(.el-form-item.is-required:not(.is-no-asterisk)) {
  .el-form-item__label:before {
    color: #ff4d4f;
  }
}

.param-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.object-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;

  .object-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .object-form {
    background: #fff;
    padding: 15px;
    border-radius: 4px;
  }
}

// 参数配置样式优化
.param-config-container {
  .param-form {
    background: #ffffff;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    }

    .param-form-item {
      margin-bottom: 16px;
      
      :deep(.el-form-item__label) {
        line-height: 40px;
        padding-right: 20px;
      }
      
      :deep(.el-form-item__content) {
        line-height: 40px;
      }
    }
  }

  .param-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px;
    background: #f8fafc;
    border-radius: 8px;
    margin-bottom: 12px;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      background: #f1f5f9;
      transform: translateX(4px);
    }

    .param-inputs {
      display: flex;
      flex-direction: row;
      gap: 16px;
      flex: 1;
    }

    .el-input {
      flex: 1;
      transition: all 0.3s ease;

      &:hover {
        .el-input__wrapper {
          box-shadow: 0 0 0 1px #409eff;
        }
      }

      .el-input__wrapper {
        border-radius: 8px;
        background: #ffffff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
      }
    }

    .full-width-input {
      width: 550px;
      flex: 1;
    }

    .delete-btn {
      opacity: 0.7;
      transition: all 0.3s ease;
      
      &:hover {
        opacity: 1;
        transform: scale(1.1);
      }
    }
  }

  .add-param-btn {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    
    .el-button {
      padding: 10px 24px;
      border-radius: 8px;
      font-weight: 500;
      background: linear-gradient(135deg, #409eff, #36a3f7);
      border: none;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    padding: 16px 0;
    margin-top: 24px;
    border-top: 1px solid #ebeef5;

    .el-button {
      padding: 10px 24px;
      border-radius: 8px;
      font-weight: 500;
      transition: all 0.3s ease;

      &.el-button--default {
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        
        &:hover {
          background: #f1f5f9;
          border-color: #cbd5e1;
        }
      }

      &.el-button--primary {
        background: linear-gradient(135deg, #409eff, #36a3f7);
        border: none;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
        }
      }
    }
  }
}

// 对象集合参数样式优化
.object-collection {
  .object-container {
    background: #ffffff;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    }

    .object-form {
      background: #f8fafc;
      border-radius: 8px;
      padding: 20px;
      margin-top: 16px;
      transition: all 0.3s ease;

      &:hover {
        background: #f1f5f9;
      }

      .param-form-item {
        margin-bottom: 16px;
        
        :deep(.el-form-item__label) {
          line-height: 40px;
          padding-right: 20px;
        }
        
        :deep(.el-form-item__content) {
          line-height: 40px;
        }
      }
    }

    .object-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid #ebeef5;

      .object-title {
        font-size: 16px;
        font-weight: 600;
        color: #1f2f3d;
      }
    }
  }

  .add-object-btn {
    display: flex;
    justify-content: center;
    margin-top: 24px;

    .el-button {
      padding: 10px 24px;
      border-radius: 8px;
      font-weight: 500;
      background: linear-gradient(135deg, #409eff, #36a3f7);
      border: none;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
      }
    }
  }
}

// 普通集合参数样式优化
.simple-collection {
  .param-form {
    .param-form-item {
      margin-bottom: 16px;
      
      :deep(.el-form-item__label) {
        line-height: 40px;
        padding-right: 20px;
      }
      
      :deep(.el-form-item__content) {
        line-height: 40px;
      }
    }
  }

  .param-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px;
    background: #f8fafc;
    border-radius: 8px;
    margin-bottom: 12px;
    transition: all 0.3s ease;

    &:hover {
      background: #f1f5f9;
      transform: translateX(4px);
    }

    .el-input {
      flex: 1;
      transition: all 0.3s ease;

      &:hover {
        .el-input__wrapper {
          box-shadow: 0 0 0 1px #409eff;
        }
      }

      .el-input__wrapper {
        border-radius: 8px;
        background: #ffffff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
      }
    }

    .delete-btn {
      opacity: 0.7;
      transition: all 0.3s ease;
      
      &:hover {
        opacity: 1;
        transform: scale(1.1);
      }
    }
  }

  .add-value-btn {
    display: flex;
    justify-content: center;
    margin-top: 24px;

    .el-button {
      padding: 10px 24px;
      border-radius: 8px;
      font-weight: 500;
      background: linear-gradient(135deg, #409eff, #36a3f7);
      border: none;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
      }
    }
  }
}
</style>